import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, EventEmitter, Output, SimpleChange, SimpleChanges, OnChanges } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { StylingService } from '../../services/styling.service';

@Component({
  selector: 'app-split-background',
  templateUrl: './split-background.component.html',
  styleUrls: ['./split-background.component.scss']
})
export class SplitBackgroundComponent implements OnInit, AfterViewInit, OnChanges {
  @Input('backgroundListElementData') item;
  @Input('columnSize') columnSize;
  @Output() splitBackgroundRes = new EventEmitter<any>();
  @Output() changeSplitBackgroundPosition = new EventEmitter<any>()
  resValue: any;
  public itemsTable: Array<number[]>;
  public backgroundItems: any = null;
  boxWidth = 110;

  constructor(public sharedService: SharedService, public stylingService: StylingService, private _ref: ChangeDetectorRef) {

  }

  ngOnInit(): void {
    console.log(this.item)
    this.backgroundItems = this.item.value.backgroundList//.map(v => v.url)
    this._ref.detectChanges();
  }

  ngAfterViewInit() {

  }

  ngOnChanges(change:SimpleChanges) {
    console.log("CHANGES", change)
  }
  initTable(data = null) {
    this.itemsTable = this.backgroundItems.filter((_, outerIndex) => outerIndex % this.columnSize == 0) // create outter list of rows
      .map((
        _,
        rowIndex // fill each row from...
      ) =>
        this.backgroundItems.slice(
          rowIndex * this.columnSize, // ... row start and
          rowIndex * this.columnSize + this.columnSize // ...row end
        )
      );

  }

  changeValue() {
   /* let tmp = JSON.parse(JSON.stringify(this.item.value))
    console.log(this.resValue.value.listBackground, this.resValue)*/
    this.splitBackgroundRes.emit(this.item);
    this.initTable();
  }

  updateBackgroundPosition(key, list) {
    this.changeSplitBackgroundPosition.emit({key: key, list: list})
  }

  getItemsTable(rowLayout: any): number[][] {
    const { width } = rowLayout.getBoundingClientRect();
    const columnSize = Math.round(width / this.boxWidth);
    // view has been resized? => update table with new column size
    if (columnSize != this.columnSize) {
      this.columnSize = columnSize;
      this.initTable();
    }
    // console.log(this.itemsTable)
    return this.itemsTable;

  }


  getNameFromUrl(img: string) {
    //console.log(img, this.sharedService.urlToNameArray);
    let name;
    this.sharedService.urlToNameArray.forEach((item) => {
      if (item.url == img)
        name = item.name
    })

    if (this.sharedService.configForm.fullListBackgrounds)
      this.sharedService.configForm.fullListBackgrounds.map(v => {
        if (v.url == img)
          name = v.defaultName;
      })

    return name
  }

  setActiveBackground(img: any, pos: string = null) {

    this.item.value.backgroundList.map(v => {

      console.log(v.url, img.url)
      if (v.url == img.url)
        v.active = true
      else
        v.active = false;
    })

    this.changeValue();
  }

  removeBackground(img: any, pos: string = null) {
    this.item.value.backgroundList = this.item.value.backgroundList.filter(v => v.url != img.url);
    this.backgroundItems = this.item.value.backgroundList

    this._ref.detectChanges();
    this.changeValue();
    this.initTable();
  }


  drop(event: CdkDragDrop<string[]>) {


    // same row/container? => move item in same row
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      // different rows? => transfer item from one to another list
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }

    // update items after drop: flatten matrix into list
    // example: [ [1,2,3], [4,5,6] ] => [1,2,3,4,5,6]
    this.backgroundItems = this.itemsTable.reduce(
      (previous, current) => previous.concat(current),
      []
    );

    //   moveItemInArray(this.sharedService.configForm.listBackgrounds, event.previousIndex, event.currentIndex);

    //   this.sharedService.configForm.listBackgrounds = event.container.data;


    let tmp = JSON.parse(JSON.stringify(this.item));

    this.item.value.backgroundList = event.container.data;
/*
    const updatedItem = JSON.parse(JSON.stringify(this.item)); // Deep copy
    updatedItem.value.listBackground = event.container.data; 

    this.resValue = updatedItem;
    console.log(event.container.data, this.item.value.listBackground)*/

   // console.log(JSON.parse(JSON.stringify(tmp)), tmp.value.listBackground)

  //  this.updateBackgroundPosition(this.item.key, event.container.data)
     this.changeValue();
    this.initTable();
  }


}
